import React from 'react';
import { useWindowSize } from '@packages/common-ui/hooks/use-window-size';
export const sm = 640;
export const md = 768;
export const lg = 1024;
export const playable = 960;
export const xl = 1280;
export const MobileMedia = `@media (max-width: ${md - 1}px)`;
export const TabletMedia = `@media (min-width: ${md}px) and (max-width: ${lg - 1}px)`;
export const PlayableMedia = `@media (min-width: ${playable}px)`;
export const DesktopMedia = `@media (min-width: ${lg}px)`;
type DeviceDependantProps = {
  desktop?: JSX.Element;
  mobile?: JSX.Element;
  breakpoint?: 'sm' | 'md' | 'playable' | 'lg' | 'xl';
};
export const DeviceDependant = ({
  desktop = <div />,
  mobile = <div />,
  breakpoint = 'md'
}: DeviceDependantProps) => {
  const {
    windowW
  } = useWindowSize();

  // don't render anything when windowW is 0 for the initial value, so it won't render mobile view for a second and then render deskop view
  if (windowW === 0) return null;
  const breakpoints = {
    sm,
    md,
    playable,
    lg,
    xl
  };
  const currentBreakpoint = breakpoints[breakpoint];
  const isMobile = windowW < currentBreakpoint;
  return isMobile ? mobile : desktop;
};